import TrailerIconSVG from "@/public/TrailerButtonMark1.svg";
import { ICustomImage } from "@filmweb/sanity-types";
import SSectionHeader from "components/framework/SSectionHeader";
import { CMSCroppedImage } from "components/images/Image";
import { FilmwebFrontpageContent, FilmwebNews, FilmwebTrailer } from "lib/server/sanity";
import { PageElement } from "lib/types/Settings";
import Link from "next/link";
import { ReactNode } from "react";
import styles from "./FilmwebContentSection.module.css";

//#region [Props]
type FilmwebContentSectionProps = {
    filmwebElements?: PageElement[];
    content?: FilmwebFrontpageContent;
};
//#endregion

//#region [Component]
export default function FilmwebContentSection({ filmwebElements, content }: FilmwebContentSectionProps) {
    if (!filmwebElements || filmwebElements.length === 0) {
        return null;
    }

    return (<section className={styles.SFilmwebSection}>
        {filmwebElements.length === 2 && <SSectionHeader className={styles.SFilmwebSectionHeader}>Trailere og filmnytt fra Filmweb</SSectionHeader>}
        {filmwebElements.length === 1 && <>
            {filmwebElements[0].elementType === "trailers" && <SSectionHeader className={styles.SFilmwebSectionHeader}>Trailere fra Filmweb</SSectionHeader>}
            {filmwebElements[0].elementType === "news" && <SSectionHeader className={styles.SFilmwebSectionHeader}>Filmnytt fra Filmweb</SSectionHeader>}
        </>}

        {filmwebElements?.map((element, elementIndex) => {
            let frontpageElement: ReactNode | undefined;
            switch (element.elementType) {
                case "trailers":
                    frontpageElement = content?.trailers?.slice(0, 3)?.map(trailer => <FilmwebArticle key={trailer._id} article={trailer} />);
                    break;
                case "news":
                    frontpageElement = content?.news?.slice(0, 3)?.map(news => <FilmwebArticle key={news._id} article={news} />);
                    break;
            }

            return frontpageElement;
        })}
    </section>);
}
//#endregion

//#region [Props]
type FilmwebArticleProps = {
    article: FilmwebTrailer | FilmwebNews;
}
//#endregion

//#region [Component]
function FilmwebArticle({ article }: FilmwebArticleProps) {

    let image: ICustomImage | undefined;
    switch (article._type) {
        case 'trailer':
            const trailer = (article as FilmwebTrailer);
            image = trailer.imageV2 ?? trailer.filmomtale?.mainImageV2 ?? trailer.filmomtale?.imagesV2?.[0];
            break;
        case 'filmnytt':
            image = (article as FilmwebNews).imageV2?.[0];
            break;
    }


    return (<article className={styles.SFilmwebArticle}>
        <Link href={getUrl(article)} passHref legacyBehavior>
            <a className={styles.SArticleLink}>
                <div className={styles.SImageContainer}>
                    {image && <CMSCroppedImage className={styles.SArticleImage} isFilmweb image={image} width={450} heightRatio={185 / 370} />}
                    {article._type === "trailer" && <TrailerIconSVG />}
                </div>
                <h1 className={styles.SArticleTitle}>{article.title}</h1>
            </a>
        </Link>

    </article>);
}
//#endregion

//#region [Other]
function getUrl(article: FilmwebTrailer | FilmwebNews): string {
    let url: string;
    switch (article._type) {
        case 'trailer':
            url = `https://www.filmweb.no/trailere/#trailer${(article as FilmwebTrailer).videoId}`;
            break;
        case 'filmnytt':
            url = `https://www.filmweb.no/filmnytt/${(article as FilmwebNews).slug.current}`;
            break;
        default:
            url = "";
    }

    return url;
}
//#endregion